
import { defineComponent, ref, onMounted } from "vue";
import Datatable from "@/components/kt-datatable/KTdatatableheaders.vue";
import ApiService from "@/core/services/ApiService";
import store from "@/store";

interface IHeaderConfiguration {
  name?: string;
  key: string;
  sortingField?: string;
  sortable?: boolean;
}

export default defineComponent({
  name: "TableTab",
  props: {
    tableHeader: {
      type: Array as () => Array<IHeaderConfiguration>,
      required: true,
    },
    tableData: { type: Array, required: true },
    selectedType: { type: Array, required: true },
    pagetitle: { type: String, required: true },
    downloadUrl: { type: String, required: true },
    downloadprops: { type: String, required: true },
    emptyTableText: { type: String, default: "No data found" },
    loading: { type: Boolean, default: false },
    currentPage: { type: Number, default: 1 },
    enableItemsPerPageDropdown: { type: Boolean, default: true },
    total: { type: Number, default: 0 },
    rowsPerPage: { type: Number, default: 10 },
    order: { type: String, default: "asc" },
    sortLabel: { type: String, default: "" },
    isTemplateDownload: { type: Boolean, default: false },
  },
  computed: {
    getPlaceholderText() {
      if (this.colnames && this.colnames.length > 0) {
        return "";
      } else {
        return "Please select";
      }
    },
  },
  components: { Datatable },
  setup(props) {
    const colnames = ref(props.selectedType);
    const tableValues = ref(props.tableData);
    const OriginalTableHeaders = ref(props.tableHeader);
    const search = ref<string>("");
    const isTemplateDownload = ref(props.isTemplateDownload);
    const initHistoric = ref(props.tableData);
    const downloadURL: any = ref(props.downloadUrl);
    const downloadProperties: any = ref(props.downloadprops);
    const buttonloading: any = ref(false);
    onMounted(() => {
      initHistoric.value = JSON.parse(JSON.stringify(props.tableData));
    });

    const searchItems = () => {
      tableValues.value.splice(
        0,
        tableValues.value.length,
        ...initHistoric.value
      );

      if (search.value !== "") {
        const results = JSON.parse(JSON.stringify(props.tableData));
        results.splice(0);

        for (let j = 0; j < tableValues.value.length; j++) {
          if (searchingFunc(tableValues.value[j], search.value)) {
            results.push(tableValues.value[j]);
          }
        }
        tableValues.value.splice(0, tableValues.value.length, ...results);
      }
    };

    // function downloadItem() {
    //   buttonloading.value = true;
    //   console.log(downloadURL.value, downloadProperties.value, 'outside if download Item value');
    //   if (isTemplateDownload.value == false) {
    //     console.log(downloadURL.value, downloadProperties.value, 'inside if download Item value');
    //     ApiService.post(downloadURL.value, downloadProperties.value)
    //       .then((resp) => {
    //         let domainName = store.getters.DomainName.toLowerCase();
    //         let url =
    //           ApiService.vueInstance.axios.defaults.baseURL +
    //           "api/Downloadfile/dwnFile/" +
    //           domainName +
    //           "/xlsx/out/" +
    //           resp.data +
    //           "/" +
    //           0;
    //         window.open(url);
    //         buttonloading.value = false;
    //       })
    //       .catch((a) => {
    //         buttonloading.value = false;
    //         //console.log(a);
    //       });
    //   } else {
    //     console.log(downloadURL.value, downloadProperties.value, 'else download Item value');
    //     ApiService.post(downloadURL.value, downloadProperties.value)
    //       .then((resp) => {
    //         let domainName = store.getters.DomainName.toLowerCase();
    //         let url =
    //           ApiService.vueInstance.axios.defaults.baseURL +
    //           "api/Downloadfile/generic/" +
    //           resp.data +
    //           "/" +
    //           1;
    //         window.open(url);
    //         buttonloading.value = false;
    //       })
    //       .catch((a) => {
    //         buttonloading.value = false;
    //         //console.log(a);
    //       });
    //   }
    // }
    async function downloadItem() {
      buttonloading.value = true;

      try {
        const resp = await ApiService.post(
          downloadURL.value,
          downloadProperties.value
        );

        console.log("Download API response:", resp.data);
        const baseURL = ApiService.vueInstance.axios.defaults.baseURL;
        const domainName = store.getters.DomainName.toLowerCase();
        const fileName = encodeURIComponent(resp.data);

        let url;

        if (!isTemplateDownload.value) {
          url =
            `${baseURL}api/Downloadfile/dwnFile/` +
            `${domainName}/xlsx/out/${fileName}/0`;
        } else {
          url =
            `${baseURL}api/Downloadfile/generic/` +
            `${fileName}/1`;
        }

        console.log("Download URL:", url);

        window.location.href = url;

      } catch (error) {
        console.error("Download failed:", error);
        console.error("Status:", error);
        console.error("Response:", error);
      } finally {
        buttonloading.value = false;
      }
    }

    const searchingFunc = (obj, value): boolean => {
      for (let key in obj) {
        if (!(typeof obj[key] === "object")) {
          if (
            String(obj[key]).toLowerCase().trim().includes(value.toLowerCase())
          ) {
            return true;
          }
        }
      }
      return false;
    };

    return {
      search,
      searchingFunc,
      searchItems,
      colnames,
      tableValues,
      OriginalTableHeaders,
      downloadItem,
      buttonloading,
    };
  },
});
